"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _progressBar = require("./progressBar.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ProgressBar = function ProgressBar(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _progressBar.useStyles)(props);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.progress)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.progressBar)
  }));
};

exports.ProgressBar = ProgressBar;
ProgressBar.propTypes = {
  /** progress bar status */
  status: _propTypes["default"].number
};
ProgressBar.defaultProps = {
  status: 20
};